export const wixP = (wixParam, isMobile) => (isMobile ? `${wixParam}-mobile` : wixParam);
export const wixPMobile = wixParam => wixP(wixParam, true);
